import { render, staticRenderFns } from "./JobCategoryPage.vue?vue&type=template&id=551afd4e"
import script from "./JobCategoryPage.vue?vue&type=script&lang=js"
export * from "./JobCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports